import {
  differenceInDays,
  getDay,
  getHours,
  isToday,
  format,
  isTomorrow,
  getMinutes,
  addMinutes,
  isAfter,
} from "date-fns";

// 0 => Domingo/Sunday
// 1 => Segunda/Monday
// 2 => Terça/Tuesday
// 3 => Quarta/Wednesday
// 4 => Quinta/Thursday
// 5 => Sexta/Friday
// 6 => Sabado/Saturday

class DateVerifyValidate {
  isAvailableMonday(now) {
    if (getDay(now) !== 6 && getDay(now) !== 0) {
      if (getDay(now) === 5 && 12 < getHours(now)) {
        return false;
      }
      return true;
    }
    return false;
  }

  isAvailableTuesday(now) {

    if (getDay(now) !== 6 && getDay(now) !== 0) {
      if (getDay(now) === 5 && 16 <= getHours(now)) {
        return false;
      }
      return true;
    }
    return false;
  }

  isAvailableWeekend(now) {

    if (getDay(now) === 5 && getHours(now) <= 15) {
      return true;
    }
    return false;
  }

  isAvailableFromWednesdayToFriday(now, dayOrder) {

    if (differenceInDays(dayOrder, now) >= 1) {
      return true;
    }
    return false;
  }

  isAvailableForThirtyMinutes(now, dayOrder, time) {
    if (isTomorrow(dayOrder) || isAfter(dayOrder, now)) {
      return true;
    }

    if (isToday(dayOrder)) {
      var [orderH, orderM] = time.split(':');
      orderH = parseInt(orderH);
      orderM = parseInt(orderM);
      var nowH = getHours(now);
      var nowM = getMinutes(now);
      if (orderH == nowH) {
        if ((orderM - nowM) >= 30) {
          return true;
        }
        return false;
      }

      if (orderH - nowH === 1) {
        var availableTime = format(addMinutes(new Date(), 30), 'mm');
        if (orderM >= availableTime) { return true }
        return false;
      }

      if (orderH - nowH > 1) {
        return true
      };
      return false;
    }
    return false;
  }

  handleAvailableDateEntry(dayOrder, service_id, now, time) {
    let aux = getDay(dayOrder);
    // console.log(aux, dayOrder);
    if (service_id != "47") {
      //Dois dias de diferença para todos menos final de semana
      if (aux !== 0 && aux !== 6) {

        let hiddenInput = document.getElementById("userId");
        let userId = hiddenInput.value;

        let today = new Date();
        let dayOfWeek = today.getDay();

        // if(dayOfWeek == 5 || dayOfWeek == 6 || dayOfWeek == 0) {
        //   return {
        //     error: true,
        //     type: "availableDifferenceInDays",
        //     message:
        //       "Você não pode efetuar um pedido para esta data, somente se fosse com dois dias de antecedência",
        //   };
        // }
        
        // if(userId != 36 && userId != 33) {
        //   if (differenceInDays(dayOrder, now) < 1) {
        //     return {
        //       error: true,
        //       type: "availableDifferenceInDays",
        //       message:
        //         "Você não pode efetuar um pedido para esta data, somente se fosse com dois dias de antecedência",
        //     };
        //   }
        // }
      }

      //Pedido para segunda Feira
      if (aux === 1) {
        if (differenceInDays(dayOrder, now) > 4) {
          return { error: false };
        }
        if (!this.isAvailableMonday(now)) {
          return {
            error: true,
            type: "availableMonday",
            message:
              "Você não pode efetuar um pedido para esta segunda-feira, somente se estiver antes de uma sexta-feira às 12h ",
          };
        }
        return { error: false };
      }

      //Pedido para terça-feira
      if (aux === 2) {
        if (differenceInDays(dayOrder, now) > 4) {
          return { error: false };
        }
        if (!this.isAvailableTuesday(now)) {
          return {
            error: true,
            type: "availableTuesday",
            message:
              "Você não pode efetuar um pedido para esta terça-feira, somente se estiver antes de uma sexta-feira às 16h ",
          };
        }
        return { error: false };
      }

      //
      // Final de semana
      if (aux === 0 || aux === 6) {
        if (getDay(now) === 5) {
          if (differenceInDays(dayOrder, now) > 2) {
            return { error: false };
          }

          if (! this.isAvailableWeekend(now)) {
            return {
              error: true,
              type: "availableWeekendDay",
              message:
                "Você não pode efetuar um pedido para este serviço para essa data, somente se estiver antes de uma sexta-feira às 15h",
            };
          }
        }
        return { error: false };
      }

      //Quarta-Feira a Sexta-feira
      let hiddenInput = document.getElementById("userId");
        let userId = hiddenInput.value;

        let today = new Date();
        let dayOfWeek = today.getDay();

        // if(dayOfWeek == 5 || dayOfWeek == 6 || dayOfWeek == 0) {
        //   return {
        //     error: true,
        //     type: "availableDifferenceInDays",
        //     message:
        //       "Você não pode efetuar um pedido para esta data, somente se fosse com dois dias de antecedência",
        //   };
        // }
        
        // if(userId != 36 && userId != 33) {
        //   if (! this.isAvailableFromWednesdayToFriday(now, dayOrder)) {
        //     return {
        //       error: true,
        //       type: "availableFromWednesdayToFriday",
        //       message:
        //         "Você não pode efetuar um pedido para esta data, somente com dois dias de antecedência",
        //     };
        //   }
        // }
        return { error: false };

    }

    //Cafe litro urgente
    if (! this.isAvailableForThirtyMinutes(now, dayOrder, time)) {
      return {
        error: true,
        type: "availableForThirtyMinutes",
        message:
          "Você não pode efetuar um pedido para esta data, somente com 30 minutos de antecedência",
      };
    }

    return { error: false };
  }
}

export default new DateVerifyValidate();
